(function() {
    'use strict';

    if (typeof VersanisDataLayer === 'undefined') {
        return;
    }

    function initProductVariantsTracking() {
        document.addEventListener('product.variant.confirmed', function(e) {
            var data = e.detail;
            if (data && data.variantData) {
                VersanisDataLayer.ecommerce.selectItem(data.variantData);
                VersanisDataLayer.ecommerce.viewItem(data.variantData);
            }
        });
    }

    function initCartTracking() {
        var lastShippingValue = null;
        var lastPaymentValue = null;
        var trackingDebounceTimer = null;

        function getCartData() {
            var items = [];
            var totalValue = 0;
            var currencyEl = document.querySelector('[data-currency]');
            var currency = currencyEl ? currencyEl.getAttribute('data-currency') : null;
            if (!currency) {
                var currencyTextEl = document.querySelector('.quoteBoxCartBlack .float-end');
                currency = currencyTextEl ? currencyTextEl.textContent.trim() : null;
            }

            var cartItems = document.querySelectorAll('.cart-products-input');
            cartItems.forEach(function(item) {
                var modelEl = item.querySelector('[data-model]');
                var model = modelEl ? modelEl.getAttribute('data-model') : null;
                var nameEl = item.querySelector('.cart-product-name');
                var name = nameEl ? nameEl.textContent.trim() : '';
                var priceEl = item.querySelector('.cart-product-price');
                var priceText = priceEl ? priceEl.textContent.trim() : '0';
                var price = parseFloat(priceText.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
                var quantityEl = item.querySelector('.cartInputValue');
                var quantity = quantityEl ? parseInt(quantityEl.value) || 1 : 1;

                if (model) {
                    items.push({
                        model: model,
                        name: name,
                        price: price,
                        quantity: quantity,
                        currency: currency
                    });
                    totalValue += price * quantity;
                }
            });

            if (items.length === 0) {
                var totalEl = document.getElementById('price_suma') || document.querySelector('.quotePrice.price span:last-child');
                var totalText = totalEl ? totalEl.textContent.trim() : '0';
                totalValue = parseFloat(totalText.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
            }

            return {
                value: totalValue,
                currency: currency,
                items: items
            };
        }

        var ajaxDeliveryBox = document.getElementById('ajaxDeliveryBox');
        if (ajaxDeliveryBox) {
            ajaxDeliveryBox.addEventListener('change', function(e) {
                var target = e.target;
                if (target.id === 'selectedDelivery' && target.value && target.value !== lastShippingValue) {
                    lastShippingValue = target.value;
                    var cartData = getCartData();
                    VersanisDataLayer.ecommerce.addShippingInfo({
                        value: cartData.value,
                        currency: cartData.currency,
                        shipping_tier: target.value,
                        items: cartData.items
                    });
                }
                if (target.id === 'selectedPayment' && target.value && target.value !== lastPaymentValue) {
                    lastPaymentValue = target.value;
                    var cartData = getCartData();
                    VersanisDataLayer.ecommerce.addPaymentInfo({
                        value: cartData.value,
                        currency: cartData.currency,
                        payment_type: target.value,
                        items: cartData.items
                    });
                }
            });

            var observer = new MutationObserver(function() {
                clearTimeout(trackingDebounceTimer);
                trackingDebounceTimer = setTimeout(function() {
                    var newDelivery = document.getElementById('selectedDelivery');
                    var newPayment = document.getElementById('selectedPayment');

                    if (newDelivery && newDelivery.value && newDelivery.value !== lastShippingValue) {
                        lastShippingValue = newDelivery.value;
                        var cartData = getCartData();
                        VersanisDataLayer.ecommerce.addShippingInfo({
                            value: cartData.value,
                            currency: cartData.currency,
                            shipping_tier: newDelivery.value,
                            items: cartData.items
                        });
                    }

                    if (newPayment && newPayment.value && newPayment.value !== lastPaymentValue) {
                        lastPaymentValue = newPayment.value;
                        var cartData = getCartData();
                        VersanisDataLayer.ecommerce.addPaymentInfo({
                            value: cartData.value,
                            currency: cartData.currency,
                            payment_type: newPayment.value,
                            items: cartData.items
                        });
                    }
                }, 150);
            });

            observer.observe(ajaxDeliveryBox, {
                childList: true,
                subtree: true
            });
        }
    }

    function initPromotionTracking() {
        var bannerImages = document.querySelectorAll('.banner-promotion-img');
        
        bannerImages.forEach(function(img) {
            var bannerId = img.getAttribute('data-banner-id');
            var bannerName = img.getAttribute('data-banner-name') || 'Banner';
            var creativeSlot = img.getAttribute('data-creative-slot') || 'banner_top_home';
            
            var trackPromotion = function() {
                if (img.getAttribute('data-promotion-tracked') === 'true') {
                    return;
                }
                img.setAttribute('data-promotion-tracked', 'true');
                
                VersanisDataLayer.ecommerce.viewPromotion({
                    id: bannerId,
                    name: bannerName,
                    creative_slot: creativeSlot
                });
            };
            
            if (img.complete && img.naturalHeight !== 0) {
                trackPromotion();
            } else {
                img.addEventListener('load', trackPromotion);
            }
        });

        var bannerLinks = document.querySelectorAll('.banner-promotion-link');
        
        bannerLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                var bannerId = this.getAttribute('data-banner-id');
                var bannerName = this.getAttribute('data-banner-name') || 'Banner';
                var creativeSlot = this.getAttribute('data-creative-slot') || 'banner_top_home';
                
                VersanisDataLayer.ecommerce.selectPromotion({
                    id: bannerId,
                    name: bannerName,
                    creative_slot: creativeSlot
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initProductVariantsTracking();
            initCartTracking();
            initPromotionTracking();
        });
    } else {
        initProductVariantsTracking();
        initCartTracking();
        initPromotionTracking();
    }
})();

